// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider as MUIStyledEngineProvider, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import React from 'react';
/**
 * Helper component that sets up all the necessary Material UI and Emotion style providers
 * for the Aurora Design System.
 *
 * @param theme - Your application's theme from MUI's `createTheme`
 * @example
 * import { createTheme } from '@mui/material/styles';
 * import { ThemeProvider } from '@aurora/aurora-design-system';
 * import { createThemeOption } from '@aurora/aurora-design-system';
 *
 * const themeOption = createThemeOption('light');
 * const theme = createTheme(themeOption);
 *
 * function App() {
 *  <ThemeProvider theme={theme}>
 *      // All of your application's content
 *  </ThemeProvider>
 * }
 */ export var ThemeProvider = function(param) {
    var children = param.children, theme = param.theme;
    return /*#__PURE__*/ React.createElement(MUIStyledEngineProvider, {
        injectFirst: true
    }, /*#__PURE__*/ React.createElement(MUIThemeProvider, {
        theme: theme
    }, /*#__PURE__*/ React.createElement(CssBaseline, null), /*#__PURE__*/ React.createElement(EmotionThemeProvider, {
        theme: theme
    }, children)));
};

//# sourceMappingURL=ThemeProvider.js.map